export function sc_binary_search_iterative(a, value) {
  var low = 0,
    high = a.length - 1,
    mid;
  while (low <= high) {
    mid = Math.floor((low + high) / 2);
    if (a[mid].fDataObjID > value) high = mid - 1;
    else if (a[mid].fDataObjID < value) low = mid + 1;
    else if (low !== mid)
      // retrieve the leftmost result index
      high = mid;
    // if we overstep past the leftmost idx of value, next loop will shift low forward by 1, which shifts mid forward by 1, and retrieves leftmost index
    else return mid;
  }
  return null;
}
